<template>
  <v-card :elevation="this.elevation">
    <v-card-title>
      {{ this.title }}
      <v-spacer/>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon @click.stop="onFolderAdd" :disabled="disabledFolderAdd" v-show="visibleFolderAdd" v-on="on">mdi-folder-plus</v-icon>
        </template>
        <span>工種フォルダ作成</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon @click.stop="onFileAdd" :disabled="disabledFileAdd" v-show="visibleFileAdd" v-on="on">mdi-file-plus</v-icon>
        </template>
        <span>工種作成</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon @click.stop="onUnSelected" :disabled="disabledUnSelected" v-show="visibleUnSelected" v-on="on">mdi-selection</v-icon>
        </template>
        <span>選択解除</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon @click.stop="onEdit" :disabled="disabledEdit" v-show="visibleEdit" v-on="on">mdi-circle-edit-outline</v-icon>
        </template>
        <span>工種名称変更</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon @click.stop="onRemove" :disabled="disabledDelete" v-show="visibleDelete" v-on="on">mdi-delete</v-icon>
        </template>
        <span>工種削除</span>
      </v-tooltip>
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <!-- <v-container> -->
        <liquor-tree class="scroll" ref="someTree" :data="this.items" :options="this.options" @node:selected="onSelected">
          <span slot-scope="{ node }" class="node-container">
            <div class="node-text">
              <template v-if="node.hasChildren()">
                <v-icon>{{ node.expanded() ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
                {{ node.text }}
              </template>
              <template v-else>
                <v-icon>mdi-file</v-icon>
                {{ node.text }}
              </template>
              <template>
                <!-- mdi-file-tree -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small class="ml-6" @click.stop="onTemplate(node)" :disabled="disabledTemplate" v-show="visibleTemplate" v-on="on">mdi-file-tree</v-icon>
                  </template>
                  <span>テンプレート反映</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small class="ml-2" @click.stop="onCopy(node)" :disabled="disabledCopy" v-show="visibleCopy" v-on="on">mdi-content-copy</v-icon>
                  </template>
                  <span>コピー</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small class="ml-2" @click.stop="onReflect(node)" :disabled="disabledReflect" v-show="visibleReflect" v-on="on">mdi-check-bold</v-icon>
                  </template>
                  <span>コピー反映</span>
                </v-tooltip>
              </template>
            </div>
          </span>
        </liquor-tree>
      <!-- </v-container> -->
    </v-card-text>
  </v-card>
</template>

<script>
import { TreeStateActions } from "@/store/module/tree-state";
import LiquorTree from 'liquor-tree';
import "vuetify/dist/vuetify.min.css";

export default {
    name: "CustomTreeView",
    components: {
        LiquorTree
    },
    data: () => ({
      selectedNode: null,
      disabledFolderAdd: false,
      disabledFileAdd: false,
      disabledTemplate: false,
      disabledCopy: false,
      disabledReflect: true,
      disabledUnSelected: true,
      disabledEdit: true,
      disabledDelete: true
    }),
    props: {
      elevation: {
        type: Number,
        default: 1
      },
      title: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        required: true
      },
      options: {
        type: Object,
        default: function () {
          return {
            parentSelect: true,
            dnd: true
          }
        }
      },
      visibleFolderAdd: {
        type: Boolean,
        default: true
      },
      visibleFileAdd: {
        type: Boolean,
        default: true
      },
      visibleTemplate: {
        type: Boolean,
        default: true
      },
      visibleCopy: {
        type: Boolean,
        default: true
      },
      visibleReflect: {
        type: Boolean,
        default: true
      },
      visibleUnSelected: {
        type: Boolean,
        default: true
      },
      visibleEdit: {
        type: Boolean,
        default: true
      },
      visibleDelete: {
        type: Boolean,
        default: true
      }
    },
    mounted() {
      this.$store.dispatch(TreeStateActions.updateTree, this.$refs.someTree);
    },
    watch: {
      items() { this.setItems(); }
    },
    methods: {
      setItems() {
        let model = this.$refs.someTree.tree.parse(this.items);
        this.$set(this.$refs.someTree, 'model', model);
        this.$refs.someTree.tree.setModel(model);
        var node = this.$refs.someTree.tree.selected();
        if (node) {
          node.unselect();
        }
      },
      checkState() {
        this.disabledFolderAdd = false;
        this.disabledFileAdd = false;

        // 選択時、工種名変更・工種削除が可能
        if (this.selectedNode) {
          this.disabledUnSelected = false;
          this.disabledEdit = false;
          this.disabledDelete = false;

          // 最大5階層まで作成可能
          if (
            this.selectedNode.parent && 
            this.selectedNode.parent.parent &&
            this.selectedNode.parent.parent.parent &&
            this.selectedNode.parent.parent.parent.parent) {
              this.disabledFolderAdd = true;
              this.disabledFileAdd = true;
          } else if (
            this.selectedNode.parent && 
            this.selectedNode.parent.parent &&
            this.selectedNode.parent.parent.parent) {
              this.disabledFolderAdd = true;
          }
        } else {
          this.disabledUnSelected = true;
          this.disabledEdit = true;
          this.disabledDelete = true;
        }
      },
      onSelected(node) {
        this.selectedNode = node;
        this.checkState();
        this.$emit("onSelected", node);
      },
      onUnSelected() {
        this.selectedNode.unselect()
        this.selectedNode = null;
        this.checkState();
        this.$emit("onUnSelected");
      },
      onEdit() {
        this.$emit("onEdit");
      },
      onRemove() {
        this.selectedNode.remove();
        this.selectedNode = null;
        this.checkState();
        this.$emit("onRemove");
      },
      onFileAdd() {
        var input = { text: "New Node", data: { items: [] } };
        if (this.selectedNode && this.selectedNode.enabled()) {
          this.selectedNode.append(input);
        } else {
          this.$refs.someTree.append(input);
        }
      },
      onFolderAdd() {
        var input = { 
          text: "New Node", 
          data: { items: [] }, 
          children: [
            { text: "New Node", data: { items: [] } }
          ]
        };
        if (this.selectedNode && this.selectedNode.enabled()) {
          this.selectedNode.append(input);
        } else {
          this.$refs.someTree.append(input);
        }
      },
      onTemplate(node) {
        this.$emit("onTemplate", node);
      },
      onCopy(node) {
        this.disabledReflect = false;
        this.$emit("onCopy", node);
      },
      onReflect(node) {
        this.$emit("onReflect", node);
      }
    }
};
</script>

<style lang="scss" scoped>
  .scroll {
    overflow-y: scroll;
    height: calc(107vh - 450px);
  }
</style>